import { Navigate } from "react-router-dom";
import { useAuthentication } from "authentication/AuthenticationContext";
import loadingLogo from "images/BlogFreeRecipeLogo.png";
import React from "react";

const ProtectedRoute = ({ children }) => {
  const { loading, user } = useAuthentication();

  if (loading) {
    return (
      <div className="p1 Justify-Center">
        <img
          className="loading"
          src={loadingLogo}
          alt="spinning logo"
          id="Logo"
        />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
